import {renderToStaticMarkup} from 'react-dom/server'
import {logoMap} from './logos'

export function Logo({name}: {name: string}) {
  const Component = logoMap[name]
  if (Component) {
    return <Component />
  }
  return null
}

export function logoToDataUrl(logoName: string): string | null {
  const Component = logoMap[logoName]
  if (!Component) return null
  const svg = renderToStaticMarkup(<Component />)
  return `data:image/svg+xml,${encodeURIComponent(svg)}`
}
